import { memo, type PropsWithChildren, useCallback, useState } from "react"

import { ImageOverlayPickerOverlay } from "../../components/Overlays/ImageOverlayPickerOverlay"
import { ImageOverlayPickerContext } from "./context"
import type { ImageOverlayPickerConfig } from "./typings"

interface ImageOverlayPickerProviderProps extends PropsWithChildren {
	onOpenChange?: (open: boolean) => void
}

export const ImageOverlayPickerProvider = memo<ImageOverlayPickerProviderProps>((props) => {
	const { children, onOpenChange } = props
	const [config, setConfig] = useState<ImageOverlayPickerConfig | null>(null)

	const close = useCallback(() => {
		setConfig(null)
		onOpenChange?.(false)
	}, [onOpenChange])

	const open = useCallback(
		(func: (closeLocationPicker: () => void) => ImageOverlayPickerConfig) => {
			setConfig(func(close))
			onOpenChange?.(true)
		},
		[close, onOpenChange],
	)

	return (
		<ImageOverlayPickerContext value={open}>
			{children}
			{config && (
				<ImageOverlayPickerOverlay
					initialBounds={config.initialBounds}
					file={config.file}
					onConfirm={config.onConfirm}
					onCancel={config.onCancel}
				/>
			)}
		</ImageOverlayPickerContext>
	)
})
ImageOverlayPickerProvider.displayName = "ImageOverlayPickerProvider"
